import { axiosWithToken, axiosWithoutToken } from "@/utils/axios";
import {
  ApiResponse,
  AuthMeResponse,
  GoogleLoginPayload,
  OnboardPayload,
  RefreshTokenResponse,
  SwitchUserRolePayload,
  SwitchUserRoleResponse,
} from "@types";

class AuthenticationService {
  register(payload: {
    first_name: string;
    last_name: string;
    email: string;
    phone_number: string;
    password: string;
    role: string;
  }) {
    return axiosWithoutToken.post("/auth/start_signup", {
      ...payload,
    });
  }
  switchUserRole(payload: SwitchUserRolePayload) {
    return axiosWithToken().post<SwitchUserRoleResponse>(
      "/auth/switch_role",
      payload,
    );
  }
  getMe(): Promise<{ data: AuthMeResponse }> {
    return axiosWithToken().get("/auth/me");
  }

  refreshToken(): Promise<{ data: RefreshTokenResponse }> {
    return axiosWithToken().get("/auth/refresh_token");
  }

  logout() {
    return axiosWithToken().post("/auth/logout");
  }

  checkPhoneAvailability(phone_number: string) {
    return axiosWithoutToken.post("/auth/check_phone", { phone_number });
  }

  verifyUser(payload: { otp_code: string; email: string }) {
    return axiosWithoutToken.post("/auth/verify_user", {
      ...payload,
    });
  }

  resendOTP(payload: { email: string }) {
    return axiosWithoutToken.post("/auth/resend_otp", {
      ...payload,
    });
  }

  forgotPassword(payload: { email: string }) {
    return axiosWithoutToken.post("/auth/forget_password", {
      ...payload,
    });
  }

  verifyResetOTP(payload: { email: string; otp_code: string }) {
    return axiosWithoutToken.post("/auth/verify_otp", {
      ...payload,
    });
  }

  resetPassword(payload: { email: string; password: string }) {
    return axiosWithoutToken.post("/auth/reset_password", {
      ...payload,
    });
  }

  login(payload: { email: string; password: string }) {
    return axiosWithoutToken.post("/auth/login", {
      ...payload,
    });
  }
  googleLogin(payload: GoogleLoginPayload) {
    return axiosWithoutToken.post("/auth/login_google", payload);
  }

  appleLogin(payload: { id_token: string; code?: string; state?: string }) {
    return axiosWithoutToken.post("/auth/login_apple", payload);
  }

  onboard(payload: OnboardPayload) {
    return axiosWithoutToken.patch("/auth/complete_signup", {
      ...payload,
    });
  }
}

const AuthService = new AuthenticationService();
export default AuthService;
